import { Spin } from 'antd'
import { useEffect } from 'react'

import { getArticleParams } from '@api/hernest/article/useArticleDetail'
import { getBlogId } from '@api/hernest/blog/useBlogDetail'
import { getCategoryId, urlQueryHandle } from '@api/hernest/products/useEntry'
import { getSuccessOrderParams } from '@api/home/shopCart/statement/useStatement'
import { getSkuId } from '@api/home/detail/useDetail'
import { initialState } from '@api/home/home/homeSlice'
import { isMobileProject, px2vw } from '@utils/index'
import { getProductOtherMetaInfo } from '@utils/SSR'
import { Type } from '@utils/tool'
import { IRoute } from './types'

// import { IRoute } from './utils'

type PRoute = Partial<IRoute>

/**
 *
 * ssr请求配置文件
 */
const SSR_API = {
  home: (terminal: string) =>
    ({
      action: (request) =>
        request.get('/page/detail', { terminal, page: 'home' }).then((res) => {
          return res.data
        }),
      initialState
    }) as PRoute,
  product: {
    action: (request, pathname) => {
      const id = getSkuId(pathname)
      const isItem = +(pathname?.indexOf?.('/item/') > -1)
      return request
        .get('/product/getProductInfo', {
          productsSkuId: id,
          item_products_id: isItem
        })
        .then((res) => {
          //自定义514 停售商品逻辑处理
          if (res.code === 514 || res.code === 500) {
            throw new Error(JSON.stringify(res))
          }
          return res.data
        })
    }
  } as PRoute,
  blog: {
    action(request, pathname, body) {
      const id = getBlogId(pathname)
      return request
        .get('/blog/detail', { id })
        .then((res) => {
          return {
            origin: body.origin,
            isError: !!Array.isArray(res.data),
            ...res.data
          }
        })
        .catch((err) => {
          throw new Error(err)
        })
    }
  } as PRoute,
  categoryInfo: {
    // 当前主要处理meta
    matchquery: true,
    action(request, pathname, body) {
      const id = getCategoryId(pathname)
      // 类目页、自定义产品页
      if (id) {
        const params: any = {
          cat_id: id,
          url_path: pathname
        }
        return request
          .get('/category/getCategoryInfo', params)
          .then((res) => {
            return {
              origin: body.origin,
              isError: !!Array.isArray(res.data),
              ...res.data
            }
          })
          .catch((err) => {
            throw new Error(err)
          })
      } else {
        return new Promise((resolve, reject) => {
          const data = getProductOtherMetaInfo(pathname, body.href)
          resolve(data)
        })
      }
    }
  } as PRoute,
  articleDetail: {
    action(request, pathname, body) {
      const params: any = getArticleParams(body.href)
      return request
        .get('/articles/getArticleInfo', { ...params })
        .then((res) => {
          return {
            origin: body.origin,
            isError: !!Array.isArray(res.data),
            ...res.data
          }
        })
        .catch((err) => {
          return {
            errorMessage: err.message
          }
        })
    }
  } as PRoute,
  statement: {
    action: async (request, pathname, body) => {
      const params: any = getSuccessOrderParams(body.href)
      const resData = await request
        .post('/order/successOrderInfo', {
          ...params
          // errorTime: 3 // 本地调试异步状态
        })
        .then((res) => {
          const newData = Type.isEmpty(res?.data) ? {} : res?.data
          return {
            code: res.code,
            message: res.message,
            ...newData
          }
        })
      // 不用异步等待则直接发【推荐位】请求，需要异步等待则在浏览器发起请求
      let recData = {}
      const skuIds = (resData?.ordersProducts || []).map((item) => item.skuId)
      if (skuIds.length) {
        recData = await request
          .get('/product/recommend', {
            urlPath: pathname,
            pos: 1,
            skuIds: skuIds
          })
          .then((res) => {
            return Type.isEmpty(res?.data) ? {} : res?.data
          })
      }
      return { ...resData, recData }
    }
  } as PRoute,
  paymentWaitting: {
    path: '/payment-waiting',
    element: () => {
      useEffect(() => {
        setTimeout(() => {
          window.location.href = '/cart'
        }, 1000 * 15)
      }, [])
      return (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            rowGap: isMobileProject ? px2vw(40) : 24,
            flexDirection: 'column'
          }}
        >
          <p>
            <Spin spinning={true} />
          </p>
          <p style={{ fontSize: isMobileProject ? px2vw(28) : 16 }}>
            Payment processing. Please wait a moment.
          </p>
        </div>
      )
    }
  }
} as const

export default SSR_API
